import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/vercel/path1/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "welcome-to-cartsy-documentation"
    }}>{`Welcome to Cartsy documentation`}</h1>
    <p><a parentName="p" {...{
        "href": "https://redq.io/cartsy"
      }}><img alt="Cartsy" src="https://s3.amazonaws.com/redqteam.com/cartsy_asset/email-banner.jpg" /></a></p>
    <h1 {...{
      "id": "sell-anything-with-cartsy"
    }}>{`Sell Anything with Cartsy!`}</h1>
    <p>{`Create your online shop with our fully functional WordPress E-commerce. Cartsy is a highly intuitive `}<br />{`
WooCommerce theme that will handle all your online business needs. Start selling anything and everything today.`}</p>
    <h3 {...{
      "id": "video-tutorial"
    }}><a parentName="h3" {...{
        "href": "https://www.youtube.com/watch?v=C6P21idUAdQ"
      }}>{`Video Tutorial`}</a></h3>
    <h3 {...{
      "id": "customer-support"
    }}><a parentName="h3" {...{
        "href": "https://member.redq.io/"
      }}>{`Customer Support`}</a></h3>
    <h2 {...{
      "id": "our-best-selling-ecommerce-product"
    }}>{`Our Best Selling ECommerce Product`}</h2>
    <ol>
      <li parentName="ol"><a href="https://redq.io/pickbazar-laravel" target="_blank">Pickbazar Laravel - React, Next, REST & GraphQL Ecommerce With Multivendor</a></li>
      <li parentName="ol"><a href="https://redq.io/pixer" target="_blank">Pixer - React Laravel Multivendor Digital Marketplace</a></li>
      <li parentName="ol"><a href="https://themeforest.net/item/pickbazar-react-graphql-ecommerce-template/25283305?s_rank=3" target="_blank">PickBazar - React Ecommerce Template</a></li>
      <li parentName="ol"><a href="https://themeforest.net/item/turbo-car-rental-system-wordpress-theme/17156768?s_rank=4" target="_blank">Turbo - WooCommerce Rental & Booking Theme</a></li>
      <li parentName="ol"><a href="https://codecanyon.net/item/rnb-woocommerce-rental-booking-system/14835145?s_rank=9" target="_blank">RnB - WooCommerce Booking & Rental Plugin</a></li>
      <li parentName="ol"><a href="https://codecanyon.net/item/reactive-pro-advanced-wordpress-search-filtering-grid/17425763?s_rank=7" target="_blank">Reactive Search Pro - Advanced WordPress Search Filter Map & Grid</a></li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      